module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Slug",
      "id": "slug",
      "error": _vm.form.errors.get('slug')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.slug),
      callback: function($$v) {
        _vm.$set(_vm.form, "slug", $$v)
      },
      expression: "form.slug"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Name",
      "id": "name",
      "error": _vm.form.errors.get('name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Save")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04640947"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/forms/TagForm.vue
// module id = 493
// module chunks = 0